import { Day, DayTypeType } from './day.interface';
import { Festival } from './festival.interface';
import { Package } from './package.interface';
import { Product } from './product.interface';

export type LodgeOrientation = 'row' | 'column';

export interface Lodge {
  id?: number;
  title: string;
  title_public?: string | null;
  layout_columns: number;
  layout_rows: number;
  orientation: LodgeOrientation;
  public: number | boolean;
  selectable: number | boolean;
  table_factors: number[];
  grid_conf: LodgeGridConf;
  created_at?: string;
  updated_at?: string;
  tables?: Table[];
  products?: Product[];
  packages?: Package[];
  days?: Day[];
}

export interface LodgeGridConf {
  column: LodgeGridConfPos;
  row: LodgeGridConfPos;
  bgcolor: string;
  color: string;
  rotate: boolean | number;
}

export interface LodgeGridConfPos {
  pos: number;
  span: number;
}

export interface LodgeSelectOptions {
  id?: number;
  title: string;
}

export interface LodgeGridConfParams {
  id?: number;
  grid_conf: LodgeGridConf;
}

export type TableType = 'table' | 'spacer' | 'lane';

export interface Table {
  id?: number;
  lodge_id?: number;
  type: TableType;
  title: string;
  position: number;
  seats: number;
  created_at?: string;
  updated_at?: string;
  bookings?: Booking[];
}

export interface Booking {
  id?: number;
  customer_id: number;
  festival_id: number;
  lodge_id: number;
  day_id: number;
  date: string;
  daytype: DayTypeType;
  reservation_id: number;
  table_id: number;
  seats_booked: number;
  created_at?: string;
  updated_at?: string;
  festival?: Festival;
  table?: Table;
  day?: Day;
  lodge?: Lodge;
}

export interface CustomerTableBooking {
  id?: number;
  table_id: number;
  table_title: string;
  seats_booked: number;
  max_seats: number;
}

export interface FestivalToLodge {
  lodge_ids: [];
}
